import { LanguagesEnum } from "common/enums/languages";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translations from "./index";

i18n.use(LanguageDetector).init({
  fallbackLng: LanguagesEnum.ENGLISH,
  lng: LanguagesEnum.ENGLISH,
  debug: false,
  resources: translations,
  ns: ["common"],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

i18n.languages = [LanguagesEnum.ENGLISH, LanguagesEnum.GERMAN];

export default i18n;
